export default "__VITE_ASSET__DYxGdxrU__"